import { useEffect, useState } from "react";
import { MapPin, X, Sparkles } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const KEY = "masar_announce_mena_turkey_v1";

export default function AnnouncementBar() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    try {
      const dismissed = window.localStorage.getItem(KEY) === "dismissed";
      setVisible(!dismissed);
    } catch {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    try {
      window.localStorage.setItem(KEY, "dismissed");
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="masar-announcement"
      className="relative z-[60] bg-gradient-to-r from-[#FF6A1A] via-[#ff7d38] to-[#FF6A1A] text-white"
    >
      <div className="absolute inset-0 masar-noise opacity-25 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-8 h-9 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <Sparkles size={14} className="shrink-0" />
          <span className="text-[11px] sm:text-xs font-medium truncate">
            <span className="hidden sm:inline">{t("announce.prefix")}</span>
            {t("announce.text")}
          </span>
          <MapPin size={14} className="shrink-0 hidden sm:inline" />
        </div>
        <button
          data-testid="masar-announcement-close"
          onClick={dismiss}
          aria-label={t("announce.dismiss")}
          className="shrink-0 h-6 w-6 rounded-full inline-flex items-center justify-center hover:bg-white/15 transition-colors"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
